import { render, staticRenderFns } from "./P008.vue?vue&type=template&id=d24f1a7e"
import script from "./P008.vue?vue&type=script&lang=js"
export * from "./P008.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports